import * as React from 'react';
import { debounce } from 'lodash';

import FiltersContainerView from './filters-container.view';

import { openFiltersDialog, closeFiltersDialog } from '../../redux-state/actions/calendar.actions';

import { ICalendarAppState } from '../../redux-state';
import { connect, Dispatch } from 'react-redux';
import { findDOMNode } from 'react-dom';

import A11yDialog = require('a11y-dialog');

interface StateToProps {
    desktopToMobileTransitionWidth: number;
    filtersDialogOpen: boolean;
}

/**
 * Dispatch methods coming from Redux
 */
interface DispatchToProps {
    openFilterDialog: (trigger: HTMLButtonElement) => void;
    closeFiltersDialog: () => void;
}

interface ModalControlMethods {
    showModal: () => void;
    hideModal: () => void;
}

interface FiltersContainerViewExternalProps {
    isModal: boolean;
}

/**
 * Filter internal state
 */
export interface FilterState {
    useModal: boolean;
}

export interface IFilterContainer {
    isMobile?: true;
}


export type FiltersContainerProps = IFilterContainer & StateToProps & DispatchToProps;
export type FiltersContainerViewProps = FiltersContainerProps & FiltersContainerViewExternalProps & ModalControlMethods;

export class FiltersContainerBase extends React.Component<FiltersContainerProps, FilterState> implements ModalControlMethods {
    private dialog;

    constructor(props: FiltersContainerProps) {
        super(props);
        this.state = { useModal: false }
    }

    initializeModal() {

        if (this.dialog) {
            this.dialog.create();
        } else {
            const element = findDOMNode(this);
            this.dialog = new A11yDialog(element);
        }
    }

    destroyModal() {
        if (this.dialog) {
            // Hide the dialog, then unbind all listeners and finally set to null.
            this.dialog.destroy();
        }
    }

    /**
     * Shift filters in and out of modal based on screen size
     */
    componentDidMount() {
        this.handleResize(this.props);
        window.addEventListener('resize', debounce(()=>this.handleResize(this.props), 50));
    }
    handleResize(props: FiltersContainerProps) {
        const useModal = this.props.desktopToMobileTransitionWidth >= window.innerWidth;
        if (useModal != this.state.useModal) {
            this.setState({
                useModal
            });
        }
        if (this.props.filtersDialogOpen && !useModal) {
            this.props.closeFiltersDialog();
        }
    }

    componentDidUpdate(prevProps: FiltersContainerProps) {
        this.handleResize(prevProps);
    }

    componentWillUnmount() {
        this.destroyModal();
    }

    showModal() {
        if (this.dialog) {
            this.dialog.show();
        }
    }

    hideModal() {
        if (this.dialog) {
            this.dialog.hide();
        }
    }

    render() {
        return <FiltersContainerView {...this.props} isModal={this.state.useModal} showModal={this.showModal.bind(this)} hideModal={this.hideModal.bind(this)} />;
    }
}

function mapStateToProps(state: ICalendarAppState): StateToProps {
    return {
        filtersDialogOpen: state.calendar.filtersDialogOpen,
        desktopToMobileTransitionWidth: parseInt(state.calendarSettings.desktopToMobileTransitionWidth),
    }
}

/**
 * Map global dispatchers to dispatch-half of MiniCalendarProps
 */
function mapDispatchToProps(dispatch: Dispatch): DispatchToProps {
    return {
        openFilterDialog: (trigger: HTMLButtonElement) => dispatch(openFiltersDialog(trigger)),
        closeFiltersDialog: () => dispatch(closeFiltersDialog())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FiltersContainerBase);